<template>
    <div id="novel_details">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>{{id?'update work':$t('menu.work_add')}}</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="box-card">
            <el-row :gutter="20">
                <el-col :span="this.$store.state.elColNum">
                 <novel_detail_component ref="detail_componet" :form="form" @submitEvent="onSubmitHandle"></novel_detail_component>
                </el-col>
            </el-row>
            <div style="display: flex;justify-content: center">
                <el-button type="success" @click="onSubmit" size="small">{{$t('_ok')}}</el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
  import {uploadimg, isRealNum} from "../../utils/common";
  import novel_detail_component from "../../components/novel_list/novel_detail_component";
  import i18n from "../../utils/i18n";

  export default {
    name: "novel_details",
      components:{novel_detail_component},
    data() {
      return {
        form: {
          title: '',
          author: '',
          infopic: '',
          coverpic: '',
          selectpic: '',
          cateids: [],
          columnids: [],
          isfw: '',
          isnew: '',
          islong: '',
          issex: 1,
          tag: '',
          iswz: 1,
          isbg: '',
          remark: '',
          list_order: '',
          desc: '',
          paychapter: '',
          thermal: '',
          hots: '',
          likes: '',
          sharetitle: '',
          sharedesc: '',
          tchapter: '',
          coin: '',
          isrecommend: '',
          ishow: '',
          status: '',
          laguage_type: i18n.locale=='en_US'?2:1,
        },
        id:this.$route.query.id,
      }
    },
    created() {
      this.id = this.$route.query.id;
      if (this.id) {
        this.$axios.get('writer/novel/' + this.id, {}).then((res) => {
          let data = res.data;
            data.cateids=data.cateids??[]
            this.form = data;
          this.$forceUpdate()
        })
      }
    },
    methods: {
      onSubmitHandle(params) {
        if (this.id) {
          this.$axios.put("writer/novel/" + this.id, params).then((res) => {
            this.$message.success('ok');
            this.back();
          });
        } else {
          this.$axios.post("writer/novel",params).then((res) => {
            this.$message.success('ok');
            this.back()
          });
        }
      },
        onSubmit(){
            this.$refs['detail_componet'].onSubmit();
        },
      back() {
          this.$router.push({
              path: '/novel_list'
          })
      }
    }
  }
</script>

<style scoped>

</style>